<section>

    <div class="flex justify-between items-end">
        <div>
          <h1>Courses</h1>
        </div>
        <div class="flex items-center gap-3">
          @if (currentTab === 'all') {
          <div class="dropdown dropdown-bottom dropdown-end">
            <div tabindex="0" role="button" class="btn btn-sm bg-white  border flex items-center">Status: {{currentStatusLabel}} <i
                class="ri-arrow-down-s-line"></i></div>
            <ul tabindex="0"
              class="dropdown-content menu bg-base-100 rounded-box z-[1] w-auto p-2 shadow mt-2 text-sm font-semibold">
              <li><a (click)="selectStatus('all')">All</a></li>
              <li><a (click)="selectStatus('draft')">Draft</a></li>
              <li><a (click)="selectStatus('publish')">Publish</a></li>
             
            </ul>
          </div>
          }

          <div class="dropdown dropdown-bottom dropdown-end">
            <div tabindex="0" role="button" class="btn btn-sm btn-primary bg-white  border flex items-center"><i
                class="ri-add-line"></i> Create Course</div>
            <ul tabindex="0"
              class="dropdown-content menu bg-base-100 rounded-box z-[1] w-full p-2 shadow mt-2 text-sm font-semibold">
              <li><a [routerLink]="['/create-course','video']" >Video</a></li>
              <li><a [routerLink]="['/create-course','flashcard']" >Flashcard</a></li>
              <li><a [routerLink]="['/create-course','exam']" >Exam</a></li>
            </ul>
          </div>
    
        </div>
      </div>

      <div class="my-5 w-max capitalize">
        <div role="tablist" class="tabs tabs-boxed gap-1 bg-white border">
          @for (i of tabs; track $index) {
          <a role="tab" class="tab text-nowrap " (click)="changeTab(i.value)" [ngClass]="{'tab-active': currentTab === i.value}">{{i.name}}</a>
          }
    
        </div>
      </div>

      <div class="grid grid-cols-1 gap-5">
        @for (i of coursesList; track $index) {
            <app-course-card [data]="i" ></app-course-card>
        }
      </div>

        <div class="m-4 flex justify-center items-end">
          <app-pagination [data]="paginationData" (pageChange)="onPageChange($event)"></app-pagination>
        </div>





</section>